import { CondOperator } from '@nestjsx/crud-request';

export function isCondOperator(operator: any): operator is CondOperator {
  return Object.values(CondOperator).includes(operator);
}
